import React, { useContext } from 'react';

import { UserContext } from '../../context/UserContext';

import JobQualifyCheck from './JobQualifyCheck';
import JobQualifyLanding from './JobQualifyLanding';

export default function JobQualifyRoutes() {
    const { user } = useContext(UserContext);

    // If user is authenticated (any user), show the qualification check
    if (user?.id) {
        return <JobQualifyCheck />;
    }

    // If not authenticated, show the landing page with login/signup options
    return <JobQualifyLanding />;
}
